import React from 'react';
import { Link } from 'react-router-dom';

/**
 * ConversionFinalCta
 *
 * Props:
 * - conservative: conservative annual savings number
 * - onUpgrade: callback for the primary CTA button
 */
const ConversionFinalCta = ({ conservative, onUpgrade }) => {
  return (
    <div className="bg-gray-900 rounded-2xl p-8 text-center text-white">
      <h3 className="text-3xl font-bold mb-4">
        Ready to Unlock ${conservative.toLocaleString()}+ in Annual Savings?
      </h3>
      <p className="text-xl text-gray-300 mb-8">
        Join thousands of energy managers who&apos;ve transformed their facilities with RAMP
      </p>

      <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
        <button
          onClick={onUpgrade}
          className="bg-emerald-600 text-white py-4 px-8 rounded-lg font-bold text-lg hover:bg-emerald-700 transition-colors shadow-lg"
        >
          Get Professional Report - $990
        </button>
        <Link
          to="/my-assessments"
          className="bg-gray-700 text-white py-4 px-8 rounded-lg font-medium hover:bg-gray-600 transition-colors"
        >
          View Free Results
        </Link>
      </div>

      <p className="text-sm text-gray-400 mt-4">
        Questions? Call 1-800-RAMP-ENERGY or email support@relyability.ai
      </p>
    </div>
  );
};

export default ConversionFinalCta;


